(function () {
  if (window.__bookingFeeGuardLoaded) return;
  window.__bookingFeeGuardLoaded = true;

  var SECTIONS = ['main-cart-items', 'main-cart-footer', 'cart-icon-bubble', 'cart-live-region-text', 'cart-drawer'];
  var FEE_PROP = '_booking_fee';
  var inFlight = false;
  var rerenderTimer = null;

  function money(cents, format) {
    // Shopify's money_format isn't trivially available client-side.
    // Use a simple GBP-ish format; falls back to Shopify.formatMoney if present.
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format || window.Shopify.money_format); } catch (e) {}
    }
    var sym = (format && format.indexOf('£') !== -1) ? '£' : '£';
    return sym + (cents / 100).toFixed(2);
  }

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function findFeeLine(cart) {
    if (!cart || !cart.items) return null;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (it.properties && (it.properties[FEE_PROP] === 'true' || it.properties[FEE_PROP] === true)) {
        return { item: it, index: i + 1 }; // Shopify line indexes are 1-based
      }
    }
    return null;
  }

  function ticketCount(cart) {
    if (!cart || !cart.items) return 0;
    var n = 0;
    for (var i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      var isFee = it.properties && (it.properties[FEE_PROP] === 'true' || it.properties[FEE_PROP] === true);
      if (!isFee) n += it.quantity;
    }
    return n;
  }

  function removeLine(line) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: 0 })
    }).then(function (r) { return r.json(); });
  }

  function rerenderSections() {
    var url = '/' + window.location.search;
    return fetch(url + (url.indexOf('?') === -1 ? '?' : '&') + 'sections=' + SECTIONS.join(','), {
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); }).then(function (sections) {
      Object.keys(sections).forEach(function (id) {
        var html = sections[id];
        if (!html) return;
        var wrap = document.getElementById('shopify-section-' + id);
        if (!wrap) return;
        // Parse and replace inner HTML to keep wrapper attrs.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newWrap = doc.getElementById('shopify-section-' + id);
        wrap.innerHTML = newWrap ? newWrap.innerHTML : html;
      });
  return getCart().then(paintFeeRow);
    }).catch(function () {});
  }

function paintFeeRow(cart) {
  const row = document.getElementById('booking-fee-row');
  if (!row) return;
  const fee = (cart.items || []).find(i => i.properties && i.properties._booking_fee === 'true');
  if (!fee) { row.hidden = true; row.innerHTML = ''; return; }
  row.hidden = false;
row.setAttribute('style', [
  'display:flex',
  'justify-content:space-between',
  'align-items:baseline',
  'gap:1rem',
  'width:100%',
  'flex:0 0 100%',
  'margin:0 0 0.75rem',
  'font-size:1.4rem',
  'font-weight:400',
  'color:rgba(var(--color-foreground),0.75)',
].join(';'));
  row.innerHTML =
    '<span style="text-align:left;flex:1 1 auto;min-width:0;">' +
      escapeHtml(fee.product_title) +
    '</span>' +
    '<span style="text-align:right;white-space:nowrap;flex:0 0 auto;">' +
      money(fee.final_line_price) +
    '</span>';
}

function escapeHtml(s) {
  return String(s).replace(/[&<>"']/g, c => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[c]));
}

  function reconcile() {
    if (inFlight) return;
    inFlight = true;
    getCart().then(function (cart) {
      var found = findFeeLine(cart);
      var tickets = ticketCount(cart);
      if (found && tickets === 0) {
        return removeLine(found.index).then(function () { return rerenderSections(); });
      }
      paintFeeRow(cart);
    }).catch(function () {}).then(function () { inFlight = false; });
  }

  function scheduleRerender() {
    if (rerenderTimer) clearTimeout(rerenderTimer);
    rerenderTimer = setTimeout(function () { reconcile(); }, 60);
  }

  // Hook cart mutation endpoints so we react to theme/AJAX cart changes.
  var CART_WRITE = /\/cart\/(change|update|add|clear)(\.js)?($|\?)/;

  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (CART_WRITE.test(url)) p.then(scheduleRerender, function () {});
    return p;
  };

  var OrigXHR = window.XMLHttpRequest;
  if (OrigXHR) {
    var open = OrigXHR.prototype.open;
    var send = OrigXHR.prototype.send;
    OrigXHR.prototype.open = function (method, url) {
      this.__url = url;
      return open.apply(this, arguments);
    };
    OrigXHR.prototype.send = function () {
      var xhr = this;
      if (this.__url && CART_WRITE.test(this.__url)) {
        this.addEventListener('load', scheduleRerender);
      }
      return send.apply(this, arguments);
    };
  }

  // Dawn dispatches this after its own cart updates.
  document.addEventListener('cart:refresh', scheduleRerender);
  document.addEventListener('cart-update', scheduleRerender);

  window.addEventListener('pageshow', reconcile);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reconcile);
  } else {
    reconcile();
  }
})();
